// jQuery(document).ready(function($){
//     if ( $(window).width() < 768) {
//         $(".page-two-columns .contain-menu").click(function() {
//           $( ".page-two-columns .contain-menu li" ).slideToggle('slow');
//           $( ".page-two-columns .contain-menu ul" ).toggleClass("active");
// 		  $( ".page-two-columns .contain-menu li" ).show();
//         });
//     }
// })

jQuery(document).ready(function($){
  if ( $(window).width() < 768) {
    $(document).ready(function(){
      $(".page-two-columns .wrapper-menu").click(function(){
        $(".page-two-columns .menu-mobile").slideToggle();
        $( ".page-two-columns .contain-menu .select-contact" ).toggleClass("active");
      });
    });
  }
})